export const WRAPPER = 'inline-flex items-center cursor-pointer';
export const DISABLED_WRAPPER = 'inline-flex items-center cursor-default';

export const BASE_CHECKBOX =
  'inline-flex items-center justify-center h-20 w-20 flex-shrink-0';

export const DEFAULT_CHECKBOX = `${BASE_CHECKBOX} border border-solid border-gray-main`;
export const CHECKED_CHECKBOX = `${BASE_CHECKBOX} bg-secondary-light`;
export const CHECKED_DARK_CHECKBOX = `${BASE_CHECKBOX} bg-secondary-light`;
export const ERROR_CHECKBOX = `${BASE_CHECKBOX} border border-solid border-red-main`;

export const CHECKBOX = {
  default: DEFAULT_CHECKBOX,
  checked: CHECKED_CHECKBOX,
  'checked-dark': CHECKED_DARK_CHECKBOX,
  error: ERROR_CHECKBOX,
};
